// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  WithdrawalDetail as Detail,
  Warning
} from '../components'

import { default as fragments } from '../fragments'

const setStateDefault = (openTab = 0) => ({
  refetch: false,
  openTab
})


class WithdrawalDetail extends React.PureComponent {
  static propTypes = {
    withdrawalId: PropTypes.string.isRequired
  }

  state = setStateDefault()

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.error && !this.state.refetch) {
      this.setState({ refetch: true })
      nextProps.data.refetch()
    }

    if (this.state.refetch) {
      this.setState({ refetch: false })
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.data.error) {
      return (
        <Warning className='u-font-size-larger slds-m-right_medium' iconSize='medium'>
          Failed to fetch withdrawal data
        </Warning>
      )
    }

    const { withdrawal } = this.props.data

    return (
      <div className='slds-size_1-of-1 stage-main'>
        <Detail
          withdrawal={withdrawal}
          identityId={withdrawal.client.identity.id}
          openTab={this.state.openTab}
          onTabClick={tabIndex => this.setState({ openTab: tabIndex })}
          refresh={this.props.data.refetch}
        />
      </div>
    )
  }
}

const getWithdrawal = gql`
  query ($id: ID!) {
    withdrawal(id: $id) {
      ...Withdrawal
    }
  }
  ${fragments.withdrawal}
`

const withData =
  graphql(getWithdrawal, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.withdrawalId || ownProps.match.params.withdrawal
      },
      fetchPolicy: 'network-only'
    })
  })

export default withData(WithdrawalDetail)



// WEBPACK FOOTER //
// ./src/containers/WithdrawalDetail.js